/**
 * Ticket-card duration copy — "1 Hour 30 Min" casing (the datetime library's
 * `formatDuration` reads "1 hour 30 minutes", so it isn't a drop-in). One
 * definition for the three summary surfaces (PR #1375 nit 2).
 *
 * @module pages/booking/shared/formatDuration
 */

export function formatDuration(minutes: number): string {
  const hours = Math.floor(minutes / 60);
  const mins = minutes % 60;
  if (hours > 0 && mins > 0) return `${hours} Hour ${mins} Min`;
  if (hours > 0) return `${hours} Hour${hours > 1 ? 's' : ''}`;
  return `${mins} Minutes`;
}
